/**  @description 自定义节点 默认 */
import { Edge, Handle, Position } from 'react-flow-renderer';
import { Tooltip, Switch, message } from 'antd';
import {
  ActionValueType,
  DataType,
  Kind,
  TableItemData,
} from '@/components/index';
import { useDispatch, useSelector } from 'umi';
import React, { useMemo } from 'react';
import Container from './container';
import { DropResult } from './box';
import _ from 'lodash';
import { HandleEventMapByLabel, SWITCH_EVENT } from '@/components/node-form';

export type ActionProp =
  | 'say'
  | 'miniProgram'
  | 'link'
  | 'image'
  | 'voice'
  | 'execute'
  | 'createGroup'
  | 'reactivateGroup'
  | 'video'
  | 'channel'
  | 'businessCard';
export type ActionType = { prop: ActionProp; label: string; value?: string };

/** @description 发送信息类型 */
export const SendActionList: ActionType[] = [
  { prop: 'say', label: '文字', value: 'text' },
  { prop: 'miniProgram', label: '小程序' },
  { prop: 'link', label: '链接' },
  { prop: 'image', label: '图片' },
  { prop: 'voice', label: '语音' },
  { prop: 'createGroup', label: '拉群' },
  { prop: 'reactivateGroup', label: '激活群' },
  { prop: 'video', label: '视频' },
  { prop: 'channel', label: '视频号' },
  { prop: 'businessCard', label: '名片' },
];

/** @description 接收回复处理类型 */
export const ReceiveActionList: ActionType[] = [
  { prop: 'execute', label: '执行', value: 'code' },
];

export const ActionMap = _.keyBy(
  [...SendActionList, ...ReceiveActionList],
  'prop',
);

export class ActionClass {
  static initSendValue() {
    const result: { [key: string]: string } = {};
    SendActionList.forEach((s) => {
      result[s.prop] = '';
    });
    return result;
  }
  static getActionPropList() {
    return [...SendActionList, ...ReceiveActionList].map(
      (a) => a.value ?? a.prop,
    );
  }
}

/** @description 获取子节点数量 */
export function getChildNodeLength(source: string, edges: Edge[]) {
  const getChildNodes = (source: string) => {
    let nodeArr: string[] = [];
    for (let i = 0; i < edges.length; i++) {
      let e: Edge = edges[i];
      if (e.source === source) {
        nodeArr.push(e.target);
      }
    }
    return nodeArr;
  };

  let loop = true;
  let sources = [source];
  let nodeArr: string[] = [];
  while (loop) {
    let _sources: string[] = [];
    sources.forEach((s) => {
      const n = getChildNodes(s);
      nodeArr = Array.from(new Set([...nodeArr, ...n]));
      _sources = [..._sources, ...n];
    });
    if (_sources.length === 0) {
      loop = false;
    } else {
      sources = _sources;
    }
  }
  return nodeArr.length;
}

function MyNode({
  data,
  selected,
}: {
  data: TableItemData;
  selected: boolean;
}) {
  const dispatch = useDispatch();
  const nodeHiddenMap = useSelector((state: any) => state.open.nodeHiddenMap);
  const edges = useSelector((state: any) => state.open.edges);
  const selectedNode = useSelector((state: any) => state.open.selectedNode);
  const selectedEdge = useSelector((state: any) => state.open.selectedEdge);

  const childCount = useMemo(() => {
    return getChildNodeLength(data.id, edges);
  }, [edges]);

  const checked = () => {
    let b_arr = nodeHiddenMap[data.id] ?? [false];
    return !b_arr[b_arr.length - 1];
  };
  const handleShowNodeChange = (value: boolean) => {
    if (!dispatch) return;
    dispatch({
      type: 'open/handleNodeHidden',
      payload: {
        hidden: !value,
        nodeId: data.id,
      },
    });
  };

  const onDrop = (item: DropResult) => {
    dispatch({
      type: 'open/handleCopyItem',
      payload: { nodeId: data.id, ...item },
    });
  };

  let borderColor = '#777';
  if (selected) borderColor = '#E0144C';
  let opacity = 1;
  if ((selectedNode && selectedNode !== data.id) || selectedEdge) opacity = 0.3;

  return (
    <Container id={data.id} onDrop={onDrop}>
      <div style={{ ...nodeStyle, borderColor, opacity }}>
        <Handle
          type="target"
          position={Position.Left}
          style={{ background: '#555' }}
        />
        <div style={{ fontSize: 12, fontWeight: 600 }}>{data.label}</div>
        {Item(
          data.isOnEnter,
          data.onEnter,
          SWITCH_EVENT.初入,
          data.label,
          data.id,
        )}
        {Item(
          data.isOnIdle,
          data.onIdle,
          SWITCH_EVENT.挽留,
          data.label,
          data.id,
        )}
        {Item(
          data.isOnReceive,
          data.onReceive,
          SWITCH_EVENT.匹配,
          data.label,
          data.id,
        )}
        <div style={switchWrapperStyle}>
          <Switch
            checkedChildren={`展开:${childCount}`}
            unCheckedChildren={`收起:${childCount}`}
            checked={checked()}
            onChange={handleShowNodeChange}
          />
        </div>
        <Handle
          type="source"
          position={Position.Right}
          style={{ background: '#555' }}
        />
      </div>
    </Container>
  );
}

export const switchWrapperStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '6px',
  // fontSize: '12px'
  transform: 'scale(0.9)',
} as React.CSSProperties;

export const nodeStyle = {
  width: 150,
  border: '1px solid #777',
  padding: 6,
  borderRadius: 8,
  background: 'rgba(255, 255, 255, 0.4)',
};

const remindStyle = {
  color: 'red',
  transform: 'scale(0.8)',
  display: 'inline-block',
  background: '#DFBB9D',
  lineHeight: 1,
  padding: '4px 6px',
  borderRadius: 4,
};
const ActionLabelStyle = {
  transform: 'scale(0.8)',
  display: 'inline-block',
  background: '#e6f7ff',
  lineHeight: 1,
  padding: '4px 6px',
  borderRadius: 4,
};
const containerStyle = {
  // background: '#f6f6f6',
  borderRadius: 4,
  padding: '2px 4px',
  fontSize: '10px',
  marginTop: 4,
  color: '#333',
} as React.CSSProperties;
const actionStyle = {
  color: '#666',
  wordBreak: 'break-word',
  paddingRight: 4,
  paddingBottom: 4,
} as React.CSSProperties;

const actionWrapperStyle = {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  background: '#F2EBE9',
  borderRadius: 4,
  paddingLeft: 4,
  paddingTop: 4,
} as React.CSSProperties;

const pointStyle = {
  width: 16,
  height: 16,
  borderRadius: '50%',
  background: '#52c41a',
} as React.CSSProperties;

export const contentValue = (value: string | number | undefined) => {
  return !value ? (
    <div className="remind-class" style={remindStyle}>
      请完善内容
    </div>
  ) : (
    <span>{value}</span>
  );
};

export const ActionContent = (data: DataType, kind: Kind) => {
  let { action, delay } = data;
  let prop = (ActionMap[action].value ??
    ActionMap[action].prop) as ActionValueType;
  let value = data[prop];

  return (
    <span style={{ color: '#333' }}>
      <span style={ActionLabelStyle}>{ActionMap[action].label}</span>
      <span>{'->'}</span>
      {kind !== 'onReceive' && (
        <span>
          {contentValue(delay)} {'->'}
        </span>
      )}
      <span>{contentValue(value)}</span>
    </span>
  );
};

const pointContent = (data: DataType, kind: Kind) => {
  let { action, delay } = data;
  let prop = (ActionMap[action].value ??
    ActionMap[action].prop) as ActionValueType;
  let value = data[prop];

  const pointValue = (isValid: boolean) => {
    return (
      <Tooltip
        color="rgba(255, 255, 255, 0.9)"
        title={() => ActionContent(data, kind)}
      >
        {!isValid ? (
          <div style={{ ...pointStyle, background: 'red' }}></div>
        ) : (
          <div style={pointStyle}></div>
        )}
      </Tooltip>
    );
  };

  let isValid = Boolean((kind === 'onReceive' && value) || (delay && value));

  return pointValue(isValid);
};

export function Item(
  isShow: boolean,
  data: DataType[],
  title: SWITCH_EVENT,
  label: string,
  id: string,
) {
  const dispatch = useDispatch();

  return (
    isShow &&
    data &&
    data.length > 0 && (
      <div style={containerStyle}>
        <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
        <div style={actionWrapperStyle}>
          {data.map((d: DataType) => (
            <div
              key={d.key}
              style={actionStyle}
              onClick={() => {
                dispatch({
                  type: 'open/showActionEditDrawer',
                  payload: {
                    kind: HandleEventMapByLabel[title].t,
                    d: d,
                    nodeId: id,
                  },
                });
              }}
            >
              {pointContent(d, HandleEventMapByLabel[title].t as Kind)}
            </div>
          ))}
        </div>
      </div>
    )
  );
}

export default React.memo(MyNode);
